import React from 'react';

export const LOGIN = React.lazy(() => import('../components/loginpage'));

export const COMING_SOON = React.lazy(() => import('../components/shared/ComingSoon'));

export const PARTNER_INSIGHTS = React.lazy(() => import('../components/PartnerInsights/main'));
export const DASHBOARD = PARTNER_INSIGHTS;

export const ACTIVITY = React.lazy(() => import('../components/Activity/main'));

export const FINANCES = React.lazy(() => import('../components/Finances/main'));

export const API_CONNECT = React.lazy(() => import('../components/ApiConnect/main'));

export const BRIEFS = React.lazy(() => import('../components/Briefs/main'));

export const SETTINGS = React.lazy(() => import('../components/SettingsPage/main'));

export const HELP_SUPPORT = React.lazy(() => import('../components/HelpSupport/main'));

export const CAMPAIGN = React.lazy(() => import('../components/Campaign/main'));

export const PARTNER_ORDERS = React.lazy(() => import('../components/PartnerOrders/main'));

export const PARTNER_TICKETS = React.lazy(() => import('../components/PartnerTickets/main'));

export const ADMIN_USERS = React.lazy(() => import('../components/adminuser/main'));

export const CLASSIC_USERS = React.lazy(() => import('../components/classicuser/main'));

export const CREATORS = React.lazy(() => import('../components/creators/main'));

// export const PRODUCTS = React.lazy(() => import('../components/products/main'));

export const PRODUCTS = React.lazy(() => import('../components/Gift/main'));

export const ITEMS = React.lazy(() => import('../components/items/main'));

export const SELFIES = React.lazy(() => import('../components/Sellfies/main'));

export const CART = React.lazy(() => import('../components/Cart/main'));

export const BRANDS = React.lazy(() => import('../components/Brands/main'));

export const ROLES = React.lazy(() => import('../components/Roles/main'));

export const CREDIT_CODES = React.lazy(() => import('../components/CreditCodes/main'));

export const CATEGORIES = React.lazy(() => import('../components/categories/main'));

export const SUBCATEGORIES = React.lazy(() => import('../components/subcategories/main'));

export const NOTIFICATION = React.lazy(() => import('../components/Notification'));